const { useCallback } = require('react');

const { connect } = require('react-redux');
const { bindActionCreators } = require('redux');
const { Card, CardContent } = require('@andes/card');
const { Title, Typography } = require('@andes/typography');
const { Button } = require('@andes/button');
const { useI18n } = require('nordic/i18n');
const classNames = require('classnames');

const stepActions = require('../../../spa/actions/step');
const { getQueryParams } = require('../../../utils/Dom');
const { STEP_NEXT } = require('../../../spa/actions/types');
const translate = require('../../../translation');
const { ZipcodeInput } = require('./ZipcodeInput');
const { ShippingOptions } = require('./ShippingOptions');
const { useShippingData } = require('./useShippingData');

const ShippingZipcodeForm = (props) => {
  const { flow, history, stepAction } = props;
  const { i18n } = useI18n();
  const translations = translate(i18n);

  const {
    data: { hasShippingOptions, selectedShippingOption, isMobile, isDesktop },
  } = useShippingData();

  const hanldeCalculate = useCallback(
    ({ locationPayload }) => {
      const urlParams = getQueryParams();

      const defaultData = {
        urlParams,
        type: flow.type,
      };

      const payload = {
        isNewInterface: true,
        shipping_action: 'calculate_shipping',
        ...locationPayload,
      };

      stepAction[STEP_NEXT](
        payload,
        flow.id,
        defaultData,
        flow.type,
        urlParams,
        history,
      );
    },
    [flow, history],
  );

  const handleNextStep = useCallback(() => {
    const urlParams = getQueryParams();

    const defaultData = {
      urlParams,
      type: flow.type,
    };

    const payload = {
      isNewInterface: true,
      shipping_action: 'continue',
      selected_ship_option: String(selectedShippingOption),
    };

    stepAction[STEP_NEXT](
      payload,
      flow.id,
      defaultData,
      flow.type,
      urlParams,
      history,
    );
  }, [flow, history, selectedShippingOption]);

  return (
    <div className="shipping-zipcode-form-v2 shipping-generics">
      <Title
        size="s"
        className={classNames('mt-40i mb-32i', { 'text-center': isMobile })}
      >
        {translations.SHIPPING_ZIPCODE_FORM_TITLE}
      </Title>

      <Card
        className="shipping-zipcode-form-card mb-24i"
        shadow={isMobile ? 'elevated' : undefined}
      >
        <CardContent className="shipping-zipcode-form-content">
          <ZipcodeInput onCalculate={hanldeCalculate} />

          {hasShippingOptions ? <ShippingOptions /> : undefined}
        </CardContent>
      </Card>

      <div
        className={classNames('footer-zipcode-form', {
          'screen-desktop': isDesktop,
        })}
      >
        {hasShippingOptions ? (
          <Button fullWidth={isMobile} onClick={() => handleNextStep()}>
            {translations.CONTINUE}
          </Button>
        ) : undefined}

        <Button
          fullWidth={isMobile}
          hierarchy="quiet"
          onClick={() => window.history.back()}
        >
          {translations.TO_GO_BACK}
        </Button>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  flow: state.page.flow,
  configs: state.configurations,
});

const mapDispatchToProps = (dispatch) => ({
  stepAction: bindActionCreators(stepActions, dispatch),
});

module.exports = {
  ShippingZipcodeForm: connect(
    mapStateToProps,
    mapDispatchToProps,
  )(ShippingZipcodeForm),
};
